// src/redux/api/operationsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { pollOperationStatus } from './operationsThunks';
import {Operation, OperationsState} from "../../../types";

const initialState: OperationsState = {
    operations: {},
    meta: {},
};

const operationsSlice = createSlice({
    name: 'operations',
    initialState,
    reducers: {
        // Синхронно устанавливаем/обновляем операцию
        setOperation: (state, action: PayloadAction<Operation>) => {
            const op = action.payload;
            // Сохраняем операцию без поля meta
            state.operations[op.id] = {
                ...op,
                meta: undefined,
            };
            // Если meta есть, сохраняем её отдельно
            if (op.meta !== undefined) {
                state.meta[op.id] = op.meta;
            }
        },
        // Удалить операцию (например, когда её результат больше не нужен)
        removeOperation: (state, action: PayloadAction<string>) => {
            delete state.operations[action.payload];
            delete state.meta[action.payload];
        },
    },
    extraReducers: (builder) => {
        // Обрабатываем наш thunk для polling операции
        builder
            .addCase(pollOperationStatus.fulfilled, (state, action: PayloadAction<Operation>) => {
                const op = action.payload;
                // Обновляем операцию без meta
                state.operations[op.id] = {
                    ...op,
                    meta: undefined,
                };
                // Если сервер вернул meta, обновляем его, иначе оставляем старое значение
                if (op.meta !== undefined) {
                    state.meta[op.id] = op.meta;
                }
            })
            .addCase(pollOperationStatus.rejected, (_state, action) => {
                console.error('Polling operation rejected:', action.error.message);
            });
    },
});

export const { setOperation, removeOperation } = operationsSlice.actions;
export default operationsSlice.reducer;
